import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import isSize from '../../utils/responsive/isSize';
import Sizes from '../../utils/responsive/Sizes';
import IconButton from '../IconButton';
import closeIcon from '../../icons/clear.svg';

const propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  close: PropTypes.func,
  fullHeight: PropTypes.bool,
  mobileTitle: PropTypes.string,
  noMargin: PropTypes.bool,
  noPadding: PropTypes.bool,
  title: PropTypes.string,
  width: PropTypes.oneOf(['regular', 'auto', 'wide']),
};

const defaultProps = {
  close: null,
  fullHeight: false,
  mobileTitle: undefined,
  noMargin: false,
  noPadding: false,
  title: null,
  width: 'regular',
};

class PopOverContainer extends React.Component {
  constructor(props) {
    super(props);

    this.scrollToBottom = this.scrollToBottom.bind(this);
  }

  scrollToBottom() {
    if (!this.scrollElement) {
      return;
    }

    this.scrollElement.scrollTop = this.scrollElement.scrollHeight;
  }

  render() {
    const { children, close, fullHeight, noMargin, noPadding, width } =
      this.props;
    const inner =
      typeof children === 'function'
        ? children({
            scrollToBottom: this.scrollToBottom,
          })
        : children;

    const mobileTitle =
      this.props.mobileTitle === undefined
        ? this.props.title
        : this.props.mobileTitle;

    const title = isSize(Sizes.SM) ? mobileTitle : this.props.title;

    return (
      <div
        className={classNames('pop-over-container', {
          'width-auto': width === 'auto',
          'width-wide': width === 'wide',
          'show-margin': !noMargin,
          'max-height-full': fullHeight,
        })}
      >
        {title && (
          <div className="pop-over-container-header">
            <div className="pop-over-container-title">{title}</div>
            <IconButton
              className="pop-over-container-close"
              onClick={close}
              applyNegativeMargin
            >
              {closeIcon}
            </IconButton>
          </div>
        )}
        <div
          className="pop-over-container-content"
          ref={(el) => {
            this.scrollElement = el;
          }}
        >
          {noPadding ? (
            inner
          ) : (
            <div className="pop-over-container-content-inner">{inner}</div>
          )}
        </div>
      </div>
    );
  }
}

PopOverContainer.propTypes = propTypes;
PopOverContainer.defaultProps = defaultProps;

export default PopOverContainer;

export const PopOverContainerArrow = React.forwardRef(
  ({ noMargin, ...props }, ref) => (
    <div
      ref={ref}
      className={classNames('pop-over-container-arrow', {
        'show-margin': !noMargin,
      })}
      {...props}
    />
  ),
);

PopOverContainerArrow.propTypes = {
  noMargin: PropTypes.bool,
};

PopOverContainerArrow.defaultProps = {
  noMargin: false,
};
